/**
 * Unified color mapping system for search criteria/segments
 * Ensures consistent color identity across:
 * - Search Criteria boxes (Table Info tab)
 * - Table column headers (for segment columns)
 * - Evaluation Breakdown cards (Row Details tab)
 */

export const SEGMENT_COLORS = [
  '#93C5FD', // Light blue (blue-300)
  '#6EE7B7', // Light green (emerald-300)
  '#C4B5FD', // Light purple (purple-300)
  '#FCD34D', // Light yellow (amber-300)
  '#FCA5A5', // Light red/pink (red-300)
  '#67E8F9', // Light cyan (cyan-300)
  '#A5B4FC', // Light indigo (indigo-300)
  '#5EEAD4', // Light teal (teal-300)
] as const;

/**
 * Get the color for a specific segment/criterion by its index
 * @param index - Zero-based index of the segment
 * @returns Hex color string
 */
export function getSegmentColor(index: number): string {
  return SEGMENT_COLORS[index % SEGMENT_COLORS.length];
}

/**
 * Get the color for a specific segment by its order number
 * (Used when segments have a segment_order property starting from 1)
 * @param order - 1-based order number of the segment
 * @returns Hex color string
 */
export function getSegmentColorByOrder(order: number): string {
  return SEGMENT_COLORS[(order - 1) % SEGMENT_COLORS.length];
}

/**
 * Get all segment colors
 * @returns Array of all segment colors
 */
export function getAllSegmentColors(): readonly string[] {
  return SEGMENT_COLORS;
}
